<template lang="pug">
FetchErrorTransition(:isFetching="isLoading" :error="error")
  .custom-field-remove
    .top-line.mb-L
      h1.h1 Delete custom field
    .panel
      .question Are you sure you want to remove custom field "{{ fieldName }}"?
      .warning All data stored in this custom field will also be deleted!
      .delete-cancel.bottom-buttons
        BriqButton(variant="text" wide @click="$router.push({name: 'CustomFieldsOverview'})" :disabled="isDeleting") No, cancel
        BriqSubmitButton(@click="deleteCustomField" :pending="isDeleting" variant="delete" pendingLabel="Deleting" data-test-id="delete-custom-field-button") Yes, delete
</template>

<script>
import { mapActions } from 'vuex'
import CustomFieldsService from '@v/settings/application/custom-fields/CustomFieldsService'

export default {
  data() {
    return {
      error: null,
      key: null,
      fieldName: null,
      isLoading: true,
      isDeleting: false,
      isMounted: false,
    }
  },
  methods: {
    ...mapActions('customFields', ['fetchCustomFieldByKey', 'fetchAllCustomFields']),
    deleteCustomField() {
      if (this.isDeleting) return
      this.isDeleting = true
      CustomFieldsService.deleteCustomField(this.key)
        .then(() => {
          this.fetchAllCustomFields()
          this.$router.push({ name: 'CustomFieldsOverview' })
          this.$notifySuccess('Custom field deleted.')
        })
        .catch(error => {
          this.$logError('There was an error: ', error.response)
          this.$notifyError('Custom field could not be deleted.')
        })
        .finally(() => {
          this.isDeleting = false
        })
    },
  },
  created() {
    this.fetchCustomFieldByKey(this.$route.params.customFieldKey)
      .then(customField => {
        this.key = customField.key
        this.fieldName = customField.fieldName
      })
      .catch(error => {
        this.error = error
        this.$notifyError(
          `Custom field for key '${this.$route.params.customFieldKey}' could not be found`,
        )
      })
      .finally(() => (this.isLoading = false))
  },
}
</script>

<style lang="stylus">
.custom-field-remove
  padding 4em 0
</style>

<style scoped lang="stylus">
.panel
  background white
  border-radius 3px
  box-shadow 0 1px 3px 0 rgba(0, 0, 0, .05)
  border solid 1px #ececec
  padding 44px 44px
  margin-bottom 48px

.warning
  font-weight bold
  padding 1em 0 2em

.bottom-buttons
  text-align center

.delete-cancel
  button:first-child
    margin-right 1em
</style>
